var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99398 1.33331C4.31398 1.33331 1.33398 4.31998 1.33398 7.99998C1.33398 11.68 4.31398 14.6666 7.99398 14.6666C11.6807 14.6666 14.6673 11.68 14.6673 7.99998C14.6673 4.31998 11.6807 1.33331 7.99398 1.33331ZM8.00065 13.3333C5.05398 13.3333 2.66732 10.9466 2.66732 7.99998C2.66732 5.05331 5.05398 2.66665 8.00065 2.66665C10.9473 2.66665 13.334 5.05331 13.334 7.99998C13.334 10.9466 10.9473 13.3333 8.00065 13.3333Z",
    fill: "#5AC7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 4.66669H7.33398V8.66669L10.834 10.7667L11.334 9.94669L8.33398 8.16669V4.66669Z",
    fill: "#5AC7F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.cfe3732a2cc1cda9ff3c3ce347bf150a.svg";
export { ForwardRef as ReactComponent };